import { PromotionBanner } from "@src/appV2/redesign/system/ui-components";
interface EarlyAccessBannerProps {
  onClick: () => void;
}

export function EarlyAccessBanner(props: EarlyAccessBannerProps) {
  return (
    <PromotionBanner
      title="Early Access Facilities"
      subtitle="Be first in line when new facilities join Clipboard. Express interest here!"
      icon="map-pin"
      borderVariant="none"
      backgroundColor={() => "rgba(76, 175, 80, 0.10)"}
      titleColor={(theme) => theme.palette.text.primary}
      ctaButtonText="Explore Facilities"
      sx={(theme) => ({
        height: "100%",
        border: `1px solid ${theme.palette.divider}`,
        "& svg": { alignSelf: "flex-start" },
      })}
      onClick={() => {
        props.onClick();
      }}
    />
  );
}
